import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.4rem 1.4rem 1.4rem;
  flex-grow: 1;
  width: 100%;
  justify-content: flex-end;
`

export const CustomTextField = styled(TextFieldMui)`
  width: 100%;
`
